/**
 * 检查摄像头是否可用
 * @param {HTMLVideoElement} ele - 视频标签元素
 * @returns {Promise<{available: boolean, error: string|null}>}
 */
export const checkCamera = async () => {
  try {
    // 请求摄像头权限
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true
    });

    // 检查是否成功获取视频流
    if (stream) {
      const tracks = stream.getVideoTracks();
      
      // 检查是否有视频轨道
      if (tracks.length === 0) {
        return {
          available: false,
          error: '未检测到摄像头设备'
        };
      }

      // 检查视频轨道状态
      const track = tracks[0];
      if (!track.enabled || !track.readyState || track.readyState === 'ended') {
        return {
          available: false,
          error: '摄像头无法启动，建议重新启动计算机'
        };
      }


      return {
        available: true,
        error: null,
        stream
      };
    }

    return {
      available: false,
      error: '无法获取视频流'
    };

  } catch (error) {
    let errorMessage = '摄像头检测失败';

    // 处理常见错误
    if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
      errorMessage = '未找到摄像头设备，建议重新拔插外接摄像头，确保接口连接正常';
    } else if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
      errorMessage = '摄像头访问权限被拒绝，请手动点击浏览器左上角的网站信息，允许网页使用摄像头';
    } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
      errorMessage = '摄像头被其他应用程序占用，请先关闭其他正在使用摄像头的网页或程序';
    } else if (error.name === 'AbortError') {
      errorMessage = '摄像头无法启动，建议重新启动计算机';
    }

    return {
      available: false,
      error: errorMessage
    };
  }
};
